<template>
  <i v-if="isRelevant" class="tm-audio-shadow">
    <tm-audio-shadow-span
      v-for="(rectangle, i) in trackRectangles"
      :key="i"
      :track="track"
      :rectangle="rectangle"
      :isFirst="i === 0"
    />
  </i>
</template>

<script>
import { mapState } from 'vuex';
import tmAudioShadowSpan from './tmAudioShadowSpan.vue';
import gridMixin from 'v/Story/Timeline/view/grid.mixin';

export default {
  name: 'tm-audio-shadow',
  mixins: [gridMixin],
  components: {
    tmAudioShadowSpan,
  },

  computed: {
    ...mapState('timemachine', {
      MODE_AUDIO_DND: (state) => state.MODE.AUDIO_DND,
      isExternal: (state) => state.dndEscort.isExternal,
      track: (state) => state.dndEscort.trackInHand,
    }),

    isRelevant() {
      return (
        this.gridEstablished &&
        this.MODE_AUDIO_DND &&
        this.isExternal &&
        !!this.track
      );
    },

    trackRectangles() {
      if (this.gridEstablished && this.track) {
        return this.$_time2rectangles(
          this.track.data.displayStartTime,
          this.track.data.displayEndTime,
          true
        );
      } else {
        return [];
      }
    },
  },

  watch: {
    trackRectangles: {
      immediate: false,
      handler(value) {
        if (this.track) {
          this.track.rectangles = value;
        }
      },
    },
  },
};
</script>

<style lang="scss">
.tm-tracks-audio > .tm-audio-shadow {
  position: absolute;
  top: 0;
  z-index: var(--tm-zAudioShadow);
}
</style>
